// extracted by mini-css-extract-plugin
export default {"header":"style_header__aY4St","body":"style_body__pTW1D","symbol":"style_symbol__5nasD","message":"style_message__NlBK8","icon":"style_icon__rJgmU","dialog":"style_dialog__QjCBx"};